export type PaginationItem = PaginationNumericItem | PaginationStringItem

export type PaginationNumericItem = number
export type PaginationStringItem = 'ellipsis'

export enum PaginationAppearance {
  BUTTONS = 'buttons',
  PLAIN = 'plain'
}
